import { gql } from "@apollo/client";


const CREATE_JUSTIFICACIONES_VISITA = gql`
mutation CreateJustificacionesVisita($input: [JustificacionVisitaInput!]!) {
    addJustificaciones(justificacionesInput: $input) {
        idJustificacionVisita
        idEvaluacion
        idProfesional
        idComboVisitaValorMotivoJustificacion
        fechaVisita
        fechaFinVisita
        fechaAlta
        observacion
    }
}`;

export default CREATE_JUSTIFICACIONES_VISITA;